/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

function getGridHeight(){
  
  setTimeout(function(){
   if( $('.ProductListWrapper .Grid__Cell .ProductItem__Info').length > 0){
    var heights = [];

    // Get all elements and push their heights to the array
    $('.ProductListWrapper .Grid__Cell .ProductItem__Info').each(function() {
        heights.push($(this).height());
    });

    // Find the maximum height from the array
    var maxHeight = Math.max.apply(null, heights);
//console.log(maxHeight);
    // Set the maximum height to all elements
    $('.ProductListWrapper .Grid__Cell .ProductItem__Info').css('height', maxHeight);
  }

    

  //recently viewed
    if( $('.Carousel__Cell .ProductItem .ProductItem__Info').length > 0){
    var heights = [];

    // Get all elements and push their heights to the array
    $('.Carousel__Cell .ProductItem .ProductItem__Info').each(function() {
      // console.log("height1",heights);
        heights.push($(this).height());
    });

    // Find the maximum height from the array
    var maxHeight = Math.max.apply(null, heights);
//console.log("height2",maxHeight);
    // Set the maximum height to all elements
    $('.Carousel__Cell .ProductItem .ProductItem__Info').css('height', maxHeight);
  }
     
  },2000);

}

function RecentlyFlickityHeight(){
  setTimeout(function(){
     if( $('.Section[data-section-id="recently-viewed-products"] .Carousel__Cell').length > 0){
    var heights = [];

    // Get all elements and push their heights to the array
    $('.Section[data-section-id="recently-viewed-products"] .Carousel__Cell').each(function() {
      // console.log("height1",heights);
        heights.push($(this).height());
    });

    // Find the maximum height from the array
    var maxHeight = Math.max.apply(null, heights);
console.log("height2",maxHeight);
    // Set the maximum height to all elements
    $('.Section[data-section-id="recently-viewed-products"] .flickity-viewport').css('height', maxHeight);
  }
  if( $('.similarproduct .flickity-viewport .Carousel__Cell').length > 0){
    var heights = [];

    // Get all elements and push their heights to the array
    $('.similarproduct .Carousel__Cell').each(function() {
      console.log("height1",heights);
        heights.push($(this).height());
    });

    // Find the maximum height from the array
    var maxHeight = Math.max.apply(null, heights);
// console.log("height2",maxHeight);
    // Set the maximum height to all elements
    $('.similarproduct .flickity-viewport').css('height', maxHeight);
  }
    
    
 // if( $('.Section[data-section-id="recently-viewed-products"] .flickity-viewport').length > 0){
 //   var maxHeight = parseFloat($('.Section[data-section-id="recently-viewed-products"] .flickity-viewport').height()) + 120;
 //   alert(maxHeight);
 //    $('.Section[data-section-id="recently-viewed-products"] .flickity-viewport').attr("style", 'height:'+maxHeight+"px");
 // }
  },2000);
}

$(document).ready(function(){
  getGridHeight();
   RecentlyFlickityHeight();
   var indexbody = $("body").hasClass("template-index");
  if(indexbody){
    setTimeout(function(){
       $('.Section[data-section-type="recently-viewed-products"] .flickity-viewport').css('height', "581px");
     },2500);
  }
   $(window).resize(function(){
     getGridHeight();
    RecentlyFlickityHeight();
  });

  /************ featured collection viewport height start **************/
      var width = $(window).width();
      console.log(width);
      if(width > 1381){
        setTimeout(function(){
          var heightBestSell = $('.Section[data-section-id="featured-collections"] .flickity-viewport').height();
              var heightPlus = heightBestSell + 20;
          $('.Section[data-section-id="featured-collections"] .flickity-viewport').height(heightPlus);
        }, 3000);
      }
  /************ featured collection viewport height end **************/
  
 /*********  Show more, Show less start **********/
  $("span.show-more").click(function(){
    $("span.show-less").show();
    $("span.show-more").hide();
   var htmlone = $(".hidden-desc").html();
    $(".mobile-view-rte").html(htmlone);
});
  $("span.show-less").click(function(){
    $("span.show-more").show();
    $("span.show-less").hide();
     var htmltwo = $(".hidden-desc-truncate").html();
      $(".mobile-view-rte").html(htmltwo);
});
   /*********  Show more, Show less end **********/
  /*********  Grid height start **********/
  var Val = $(".QuantitySelector_buttons").hasClass("disabled");
    if(Val){
        $(".quantity-jtpl").attr("disabled","disabled");
    }else{
        $(".quantity-jtpl").removeAttr("disabled");
    }
  $('.ArticleList-items').slick({
  dots: false,
  infinite: false,
  arrows: true, 
  centerMode: false,
  lazyLoad: 'progressive',
  speed: 300,
  slidesToShow: 3,
  slidesToScroll: 3,
  responsive: [
    {
      breakpoint: 999,
      settings: {
        slidesToShow: 2,
        adaptiveHeight: true,
        arrows: true
      }
    },
    {
      breakpoint: 679,
      settings: {
        slidesToShow: 1.2,
        adaptiveHeight: true,
        arrows: false
      }
    },
    {
      breakpoint: 501,
      settings: {
        slidesToShow: 1.2,
        slidesToScroll: 1,
        adaptiveHeight: true,
        arrows: false
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});
  $('.product-wrapper-bundle').slick({
    infinite: false,
    arrows: true,
    slidesToShow: 4,
    slidesToScroll: 4
  });
});

$('.sectionheading-class-main').on("click",".sectionheading-btn",function(){
  $(this).parents('.sectionheading-main').find('.mainheadingclass-toggel-div').slideToggle("slow");
  if($(this).find(".ang i").hasClass("fa-angle-down"))
  {
    $(this).find(".ang").html('<i class="fa fa-angle-up"></i>'); 
  }
  else
  {
    $(this).find(".ang").html('<i class="fa fa-angle-down"></i>'); 
  }   
});

$('.custom_Faq__ItemWrapper').on("click",".Faq__Question_custom-class",function(){
  $(".custom_Faq__ItemWrapper").removeClass("intro");
  $(this).parents(".custom_Faq__ItemWrapper").addClass("intro");
  $(this).parents('.intro').find('.Faq__AnswerWrapper_custom_ans').slideToggle("slow");
  if($(this).find(".ang i").hasClass("fa-angle-right"))
  {
    $(this).find(".ang").html('<i class="fa fa-angle-down"></i>'); 
  }
  else
  {
    $(this).find(".ang").html('<i class="fa fa-angle-right"></i>'); 
  }   
});
$(document).ready(function(){
  $('.firstclick').trigger('click');
});

$(document).ready(function() {
  if (window.innerWidth < 1008) {
    $("#stickyheader").addClass("stiker");
  }
  else{
    $(window).scroll(function() {    
      var scroll = $(window).scrollTop();
  
      if (scroll >= 500) {
        $("#stickyheader").addClass("stiker");
      } else {
        $("#stickyheader").removeClass("stiker");
      }
    });
  }
  
  $('.customplusqty').click(function(){
 var qty = parseInt($('.customqtyinput').val());
  console.log(qty);
    var pluseqty = qty + 1;
    console.log(pluseqty);
    $('.customqtyinput').val(pluseqty);
  });
  $('.customminusqty').click(function(){
 var qty = parseInt($('.customqtyinput').val());
  console.log(qty);
    if(qty > 1){
    var pluseqty = qty - 1;
    console.log(pluseqty);
    $('.customqtyinput').val(pluseqty);
    }
  });

    $("select.seleval").change(function(){
     $('select.allidselectbox option').removeAttr('selected');
    var countries = [];
    $.each($(".seleval option:selected"), function(){            
      countries.push($(this).val());
    });
      var selectoption = countries.join(" / ");
    console.log(countries.join(" / "));
      
      $('select.allidselectbox option').each(function(){
        var maivariantvalue = $(this).data('value');
        console.log(maivariantvalue);
        if(selectoption == maivariantvalue){
         $(this).attr('selected','selected');
         var varprice = $(this).data('price');
          console.log(varprice);
          $('.variantprice-apend').html(varprice);
         var varprice = $(this).data('avail');
          console.log(varprice);
          if(varprice == 1){
          console.log('variant available');
            $('.customattrbtnsoldout').css('display','none');
            $('.customattrbtnaddtocart').css('display','block');
          }else{
          console.log('variant not available');
           $('.customattrbtnsoldout').css('display','block'); 
           $('.customattrbtnaddtocart').css('display','none');
          }
        }
      });
      
  });
});
// currancy code start
 
$(document).ready(function(){
  
  $.getJSON("https://ipinfo.io", function (data) {
    var country = data.country;
    jQuery.getJSON("https://restcountries.eu/rest/v1/alpha/"+country, function (data) {
      var currency = data.currencies[0];
      $('.Popover__ValueList .Popover__Value').each(function() {
        var btn = $(this).val();
        if (document.cookie.indexOf('currancy') != -1) {
          //         console.log('not match');
        }
        else if(currency == btn){
          $(this).trigger('click');
          document.cookie = "currancy" + "=" + "yes" + ";" + ";path=/";

        }
        //     console.log(btn);
      });
    });
  });
  
});
// currancy code end





// For shipping page calculator faq
$(document).ready(function(){
  var countries = ["Afghanistan","Albania","Algeria","Andorra","Angola","Anguilla","Antigua &amp; Barbuda","Argentina","Armenia","Aruba","Australia","Austria","Azerbaijan","Bahamas","Bahrain","Bangladesh","Barbados","Belarus","Belgium","Belize","Benin","Bermuda","Bhutan","Bolivia","Bosnia &amp; Herzegovina","Botswana","Brazil","British Virgin Islands","Brunei","Bulgaria","Burkina Faso","Burundi","Cambodia","Cameroon","Canada","Cape Verde","Cayman Islands","Central Arfrican Republic","Chad","Chile","China","Colombia","Congo","Cook Islands","Costa Rica","Cote D Ivoire","Croatia","Cuba","Curacao","Cyprus","Czech Republic","Denmark","Djibouti","Dominica","Dominican Republic","Ecuador","Egypt","El Salvador","Equatorial Guinea","Eritrea","Estonia","Ethiopia","Falkland Islands","Faroe Islands","Fiji","Finland","France","French Polynesia","French West Indies","Gabon","Gambia","Georgia","Germany","Ghana","Gibraltar","Greece","Greenland","Grenada","Guam","Guatemala","Guernsey","Guinea","Guinea Bissau","Guyana","Haiti","Honduras","Hong Kong","Hungary","Iceland","India","Indonesia","Iran","Iraq","Ireland","Isle of Man","Israel","Italy","Jamaica","Japan","Jersey","Jordan","Kazakhstan","Kenya","Kiribati","Kosovo","Kuwait","Kyrgyzstan","Laos","Latvia","Lebanon","Lesotho","Liberia","Libya","Liechtenstein","Lithuania","Luxembourg","Macau","Macedonia","Madagascar","Malawi","Malaysia","Maldives","Mali","Malta","Marshall Islands","Mauritania","Mauritius","Mexico","Micronesia","Moldova","Monaco","Mongolia","Montenegro","Montserrat","Morocco","Mozambique","Myanmar","Namibia","Nauro","Nepal","Netherlands","Netherlands Antilles","New Caledonia","New Zealand","Nicaragua","Niger","Nigeria","North Korea","Norway","Oman","Pakistan","Palau","Palestine","Panama","Papua New Guinea","Paraguay","Peru","Philippines","Poland","Portugal","Puerto Rico","Qatar","Reunion","Romania","Russia","Rwanda","Saint Pierre &amp; Miquelon","Samoa","San Marino","Sao Tome and Principe","Saudi Arabia","Senegal","Serbia","Seychelles","Sierra Leone","Singapore","Slovakia","Slovenia","Solomon Islands","Somalia","South Africa","South Korea","South Sudan","Spain","Sri Lanka","St Kitts &amp; Nevis","St Lucia","St Vincent","Sudan","Suriname","Swaziland","Sweden","Switzerland","Syria","Taiwan","Tajikistan","Tanzania","Thailand","Timor L'Este","Togo","Tonga","Trinidad &amp; Tobago","Tunisia","Turkey","Turkmenistan","Turks &amp; Caicos","Tuvalu","Uganda","Ukraine","United Arab Emirates","United Kingdom","United States of America","Uruguay","Uzbekistan","Vanuatu","Vatican City","Venezuela","Vietnam","Virgin Islands (US)","Yemen","Zambia","Zimbabwe"];

  function autocomplete(inp, arr) {
    /*the autocomplete function takes two arguments,
        the text field element and an array of possible autocompleted values:*/
    var currentFocus;
    /*execute a function when someone writes in the text field:*/
    inp.addEventListener("input", function(e) {
      var a, b, i, val = this.value;
      /*close any already open lists of autocompleted values*/
      closeAllLists();
      if (!val) { return false;}
      currentFocus = -1;
      /*create a DIV element that will contain the items (values):*/
      a = document.createElement("DIV");
      a.setAttribute("id", this.id + "autocomplete-list");
      a.setAttribute("class", "autocomplete-items");
      /*append the DIV element as a child of the autocomplete container:*/
      this.parentNode.appendChild(a);
      /*for each item in the array...*/
      for (i = 0; i < arr.length; i++) {
        /*check if the item starts with the same letters as the text field value:*/
        if (arr[i].substr(0, val.length).toUpperCase() == val.toUpperCase()) {
          /*create a DIV element for each matching element:*/
          b = document.createElement("DIV");
          /*make the matching letters bold:*/
          b.innerHTML = "<strong>" + arr[i].substr(0, val.length) + "</strong>";
          b.innerHTML += arr[i].substr(val.length);
          /*insert a input field that will hold the current array item's value:*/
          b.innerHTML += "<input type='hidden' value='" + arr[i] + "'>";
          /*execute a function when someone clicks on the item value (DIV element):*/
          b.addEventListener("click", function(e) {
            /*insert the value for the autocomplete text field:*/
            inp.value = this.getElementsByTagName("input")[0].value;
            /*close the list of autocompleted values,
                    (or any other open lists of autocompleted values:*/
            closeAllLists();
          });
          a.appendChild(b);
        }
      }
    });
    /*execute a function presses a key on the keyboard:*/
    inp.addEventListener("keydown", function(e) {
      var x = document.getElementById(this.id + "autocomplete-list");
      if (x) x = x.getElementsByTagName("div");
      if (e.keyCode == 40) {
        /*If the arrow DOWN key is pressed,
                increase the currentFocus variable:*/
        currentFocus++;
        /*and and make the current item more visible:*/
        addActive(x);
      } else if (e.keyCode == 38) { //up
        /*If the arrow UP key is pressed,
                decrease the currentFocus variable:*/
        currentFocus--;
        /*and and make the current item more visible:*/
        addActive(x);
      } else if (e.keyCode == 13) {
        /*If the ENTER key is pressed, prevent the form from being submitted,*/
        e.preventDefault();
        if (currentFocus > -1) {
          /*and simulate a click on the "active" item:*/
          if (x) x[currentFocus].click();
        }
      }
    });
    function addActive(x) {
      /*a function to classify an item as "active":*/
      if (!x) return false;
      /*start by removing the "active" class on all items:*/
      removeActive(x);
      if (currentFocus >= x.length) currentFocus = 0;
      if (currentFocus < 0) currentFocus = (x.length - 1);
      /*add class "autocomplete-active":*/
      x[currentFocus].classList.add("autocomplete-active");
    }
    function removeActive(x) {
      /*a function to remove the "active" class from all autocomplete items:*/
      for (var i = 0; i < x.length; i++) {
        x[i].classList.remove("autocomplete-active");
      }
    }
    function closeAllLists(elmnt) {
      /*close all autocomplete lists in the document,
            except the one passed as an argument:*/
      var x = document.getElementsByClassName("autocomplete-items");
      for (var i = 0; i < x.length; i++) {
        if (elmnt != x[i] && elmnt != inp) {
          x[i].parentNode.removeChild(x[i]);
        }
      }
    }
    /*execute a function when someone clicks in the document:*/
    document.addEventListener("click", function (e) {
      closeAllLists(e.target);
    });
  }
  autocomplete(document.getElementById("country-input"), countries);


  $('#country-input').on("change", function(evt) {
    $('#shipping-result').hide();
  });

  $('#shipping-calc').on("submit", function(evt) {
    evt.preventDefault();
    $('#shipping-result').hide();
    $('.covid-note').show();
    const country = $("#country-input").val();
    var Final_country = country.toLowerCase().replace(/ /g,'');
    var error= $(".Main_Shipping-Messages .error").text();
    var count=0;
    $(".Main_Shipping-Messages .messages").each(function(){
      var country_name = $(this).data("index").replace(/ /g,'');
      if( country_name == Final_country){
        var find_text= $(this).html();
        $("#shipping-result").html(find_text);
        $('#shipping-result').show();
        count++;
      }
      else{
      }
    });

    if(count == 0 ){
      $('#shipping-result').html(error);
      $('#shipping-result').show();
    }
  });
});


// $('.accordion-title').click(function(){
//   $(this).parent().siblings().find('.accordion-title').removeClass('active');
//   $(this).parent().siblings().find('.accordion-title').next('.accordion-content').hide();
//   $(this).toggleClass('active');
//   $(this).next('.accordion-content').toggle();
// });

// $(document).ready(function(){
//   $('.accordion-title').first().addClass("active");
//   $('.accordion-content').first().css("display","block");
// });


  $(document).on('click','button.Collapsible__Button.Heading.u-h6', function(event){
    if ($(this).hasClass("active")) {
      $(this).removeClass("active");
      $(this)
        .siblings(".Collapsible__Inner-custom")
        .slideUp(200);
      $("button.Collapsible__Button.Heading.u-h6 span")
        .removeClass("fa-minus")
        .addClass("fa-plus");
    } else {
      $("button.Collapsible__Button.Heading.u-h6 span")
        .removeClass("fa-minus")
        .addClass("fa-plus");
      $(this)
        .find("i")
        .removeClass("fa-plus")
        .addClass("fa-minus");
      $("button.Collapsible__Button.Heading.u-h6").removeClass("active");
      $(this).addClass("active");
      $(".Collapsible__Inner-custom").slideUp(200);
      $(this)
        .siblings(".Collapsible__Inner-custom")
        .slideDown(200);
    }
  });